// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandlerDiscreteParameter, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { addRma as addRmaApi, AddRmaApiParameter } from "@insite/client-framework/Services/OrderService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/RequestRma/Handlers/SendRmaRequest";
import { RmaModel } from "@insite/client-framework/Types/ApiModels";

type SendRmaRequestParameter = {
    orderNumber: string;
    onError?: (errorMessage: string) => void;
    properties: {
        phone: string;
        name: string;
        email: string;
        urgencyOfResolution: string;
        serialNumber: string;
    };
} & HasOnSuccess<RmaModel>;

type HandlerType = ApiHandlerDiscreteParameter<SendRmaRequestParameter, AddRmaApiParameter, ServiceResult<RmaModel>>;

export const XPopulateApiParameter: HandlerType = props => {
    const properties = (props.getState() as any).xRequestRma.properties;
    props.apiParameter.rmaModel = {
        ...props.apiParameter.rmaModel,
        properties,
    };
};

addToChainAfter(chain, PopulateApiParameter, XPopulateApiParameter);
